import { NamedAvatar } from '../../../../app/components/NamedAvatar/NamedAvatar';
import { Row } from '../../../../app/components/Row/Row';
import { ChatMessage } from '../../domain/types';
import {
	ChatBubbleContainer,
	ChatBubbleHeader,
	ChatBubbleMessage,
	ChatBubbleTimestamp,
	ChatBubbleUser,
} from './style';

export interface ChatBubbleProps {
	message: ChatMessage;
	sameMember: boolean;
	$mine?: boolean;
}

export function ChatBubble({ message, sameMember = true, $mine = true }: Readonly<ChatBubbleProps>) {
	return (
		<ChatBubbleContainer $mine={$mine}>
			{sameMember && (
				<ChatBubbleHeader>
					<Row $gap={12} $reverse={$mine} $vcenter>
						<NamedAvatar size={40} name={message?.fullName} />
						<ChatBubbleUser>{message?.fullName}</ChatBubbleUser>
						<ChatBubbleTimestamp>{message.timestamp}</ChatBubbleTimestamp>
					</Row>
				</ChatBubbleHeader>
			)}
			<ChatBubbleMessage $mine={$mine}>
				{message.message}
			</ChatBubbleMessage>
		</ChatBubbleContainer>
	);
}
